<template>
    <div style="height: 100vh;">
      <div id="videoContainer" ref="playerContainer" class="player"></div>
    </div>
  </template>
  
  <script>
  import OvenPlayer from 'ovenplayer';
  
  export default {
    data() {
      return {
        playerInstance: null,
        playerOption: null,
        demoOption: null,
        // message: null,
        // version: null,
        // loadButtonMsg: null,
        // loadButtonColor: null,
        // loadButtonIcon: null,
        // demoOption : {
        //     autoReload: true,
        //     autoReloadInterval: 2000
        // },
        // reloadTimer: null,

      };
    },
    created(){
        const frontPreUrl = window.location.protocol + '//' + window.location.host;
        const localurl = window.location.href;
      
        const tmpNumber = localurl.replace(frontPreUrl + '/webrtcPlayer?', '');
        // console.log('tmpNumber', tmpNumber);

        this.initSetting(tmpNumber);
    },
    mounted() {
        this.loadPlayer();
    },
    methods: {
      initSetting(tmpNumber) {

        const hash = '#%7B"playerOption"%3A%7B"autoStart"%3Atrue%2C"autoFallback"%3Atrue%2C"mute"%3Afalse%2C"sources"%3A%5B%7B"type"%3A"webrtc"%2C"file"%3A"wss%3A%2F%2Foven.dnstrip.net%3A3334%2Fwebrtclive%2Ftest"%7D%5D%2C"doubleTapToSeek"%3Afalse%7D%2C"demoOption"%3A%7B"autoReload"%3Atrue%2C"autoReloadInterval"%3A2000%7D%7D';
        // console.log("hash => ", hash)
        let urlOption = null;

        if (hash) {
            urlOption = JSON.parse(decodeURIComponent(hash.replace('#', '')));
        }
        // console.log("urlOption => ", urlOption)

        const urlParams = new URLSearchParams(window.location.search);
        const sourcefile = tmpNumber.split("=")[1] || "";
        const autoStartParam = urlParams.get('autoStart');
        const autoStartParammute = urlParams.get('mute');

        const policy = urlParams.get('policy');
        const signature = urlParams.get('signature');
        const domain = urlParams.get('domain');

        this.playerOption = {
            autoStart: true,
            autoFallback: true,
            mute: false,
            sources: [],
            doubleTapToSeek: false
        };

        if (urlOption && urlOption.demoOption) {
            this.demoOption = _.extend(this.demoOption, urlOption.demoOption);
        }

        if (urlOption && urlOption.playerOption) {  
            this.playerOption = _.extend(this.playerOption, urlOption.playerOption);
        }

        if (autoStartParam !== null) {
            this.playerOption.autoStart = autoStartParam === 'true';
        }

        if (autoStartParammute !== null) {
            this.playerOption.mute = autoStartParammute === 'true';
        }

        if (sourcefile) {
            if (this.playerOption.sources.length > 0) {
                if(signature && domain !== null) {
                    this.playerOption.sources[0].file = decodeURIComponent(sourcefile + '&signature=' + signature + '&domain=' + domain);
                }else{
                    this.playerOption.sources[0].file = decodeURIComponent(sourcefile)
                }
            } else {
                const rawFile = sourcefile + '&signature=' + signature + '&domain=' + domain;
                this.playerOption.sources.push({ type: "webrtc", file: decodeURIComponent(rawFile) });
            } 
        }
      },

      loadPlayer(){
        if(this.playerInstance){
            this.playerInstance.remove();
            this.playerInstance = null;
        }

        if(this.playerOption.sources.length == 0){
            return;
        }

        const option = JSON.parse(JSON.stringify(this.playerOption));
        console.log('sources : ', this.playerOption.sources);

        this.playerInstance = OvenPlayer.create('videoContainer', option);

        this.playerInstance.on('ready', () => {
            console.log('Player ready.');

            setTimeout(() => {
                this.playerInstance.play();
            }, 300);
        });

        this.playerInstance.once('error', (e) => {
            console.log("err => ", e);

            setTimeout(() => {
                this.playerInstance.play();
            }, 300);
        });
      },
    },
    beforeDestroy() {
        if (this.playerInstance) {
            this.playerInstance.destroy();
        }
    },
  };
  </script>
  
  <style>
#videoContainer {
  --op-accent-color: red;
  height: 100%;
}
  </style>
  